<section class="relative w-full h-[500px] md:h-[600px] lg:h-[700px] overflow-hidden flex items-center justify-center">
	<picture class="absolute inset-0 z-0 w-full h-full">
		<source [srcset]="backgroundImage | imageConverter" type="image/webp">
		<img [src]="backgroundImage" width="1920" height="700" class="w-full h-full object-cover" fetchpriority="high"
			loading="eager" alt="Fondo de {{ title }}">
	</picture>

	<div class="absolute inset-0 bg-[rgba(2,0,66,0.55)] z-10"></div>
	<div class="relative z-20 text-center text-[#F2F4FE] tracking-wider font-extralight p-4">
		<h1 class="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl mb-4">{{ title }}</h1>
		<div class="flex justify-center mt-4">
			<picture>
				<source [srcset]="'assets/svg/section/separador.svg' | imageConverter" type="image/webp">
				<img src="assets/img/separador.png" alt="Icono separador" class="w-full max-w-xs md:max-w-md"
					loading="lazy">
			</picture>

		</div>
		<div class="flex flex-col sm:flex-row items-center justify-center mt-6 space-y-4 sm:space-y-0">
			<div class="flex items-center space-x-6">
				<a href="/"
					class="relative inline-block text-sm sm:text-base xl:text-base text-[#F2F4FE] font-light group"
					role="link" tabindex="0" aria-label="Ir a la página de inicio">
					Home
					<span
						class="absolute left-1/2 bottom-0 h-[2px] w-full bg-[#F2F4FE] transform -translate-x-1/2 scale-x-0 transition-transform duration-300 group-hover:scale-x-100"></span>
				</a>
				<span class="text-sm sm:text-base xl:text-base text-[#F2F4FE] font-light">-</span>
				<span class="text-sm sm:text-base xl:text-base text-[#F2F4FE] font-light">{{ title }}</span>
			</div>
		</div>
	</div>
</section>